<template>
    <div>
        <rkm-row class="flex-nowrap" v-if="unidadeId">

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Unidade"
                    v-model="form.unidade"
                    disabled
                />
            </rkm-col>

            <rkm-col class="flex-grow-1">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="form.infraestrutura"
                    disabled
                />
            </rkm-col>
        </rkm-row>

        <Buscar
            ref="FormSearch"
            :form="form"
            :model="model"
            @handleBlur="handleBlur"
        />

        <Atribuir
            v-show="model.jornadasNotSave"
            :form="form"
            :model="model"
            :selecionados="selecionados"
            @getCalendar="getCalendar"
        />

        <rkm-row v-show="model.jornadasNotSave">
            <rkm-col>
                <rkm-button
                    @click="selecionarTodos()"
                    color="primary"
                    class="mb-2"
                >
                    <template v-if="selecionados == false">
                        Selecionar todos
                    </template>

                    <template v-else>
                        Desmarcar selecionado(s)
                    </template>
                </rkm-button>

                <template>
                    <rkm-button
                        v-if="selecionados == true"
                        @click="deletarSelecionados()"
                        color="danger"
                        class="mb-2"
                    >
                        Excluir selecionado(s)
                    </rkm-button>
                </template>
            </rkm-col>
        </rkm-row>

        <rkm-row v-show="model.jornadasNotSave">
            <rkm-col>
                <rkm-table
                    :fields="fields.tables.jornada"
                    :items="model.jornadasNotSave || model.jornadas"
                    ref="Table"
                    hide-filters
                    sort-by="data"
                    :sort-compare="sortCompare"
                >
                    <template v-slot:cell(checkbox)="{ item }">
                        <rkm-form-checkbox
                            v-model="item.selecionado"
                            @change="handleBlur"
                        />
                    </template>

                    <template v-slot:cell(diasSemana)="row">
                        {{ getStringDiaSemana(row.item.semanaId) }}
                    </template>

                    <template v-slot:cell(tempoAtendimento)="row">
                        {{ getTempoAtendimento(row.item.tempoAtendimento) }}
                    </template>

                    <template v-slot:cell(actions)="{ index, item }">

                        <rkm-button
                            color="primary"
                            title="Editar"
                            small
                            @click.stop="$emit('handleAlter', item, index)"
                            :disabled="item.agendamentos > 0"
                        >
                            <rkm-icon icon="pen" />
                        </rkm-button>

                        <rkm-button
                            color="danger"
                            title="Excluir"
                            small
                            @click.stop="handleDestroy(item)"
                           :disabled="item.agendamentos > 0"
                        >
                            <rkm-icon icon="trash" /> 
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>

import { mapActions } from 'vuex'
import { repository, error, object, data, stringCase } from '@/mixins'

// Components.
import Buscar from '@/components/exame-laboratorial/jornada/components/buscar/Form'
import Atribuir from '@/components/exame-laboratorial/jornada/components/Atribuir'

// Moment.
import moment from 'moment'

export default {
    components:{ Buscar, Atribuir },
    computed:{
        fields() {

            return {
                tables: {
                    jornada: [
                        { key: 'checkbox', label: '#',  class: 'col-min text-center', },
                        { key: 'data', label: 'Data', sortable: true },
                        { key: 'diasSemana', label: 'Dia da semana', sortable: true },
                        { key: 'horaInicial', label: 'Início', sortable: true },
                        { key: 'horaFim', label: 'Fim', sortable: true },
                        { key: 'vagas', label: 'Vagas cadastradas', sortable: true },
                        { key: 'agendamentos', label: 'Vagas utilizadas', sortable: true },
                        { key: 'vagasDisponiveis', label: 'Vagas disponíveis', sortable: true },
                        { key: 'tempoAtendimento', label: 'Tempo de atendimento', sortable: true },
                        { key: 'tipoNome', label: 'Tipo de jornada', sortable: true },
                        { key: 'actions', label: 'Ações', class: 'col-min text-center'}
                    ]
                }
            }
        },
        infraestruturas() {

            if (this.unidadeId && this.form.unidades) {

                let infraestruturaPrincipal = this.form.unidades.find(u => u.unidadeId == this.unidadeId)

                if (infraestruturaPrincipal) {

                    return infraestruturaPrincipal.infraestruturas
                }
            }

            return []
        },
    },
    created() {

        this.repositories = {
            jornada: this.getConectaSusRepository('exameLaboratorial.jornada')
        },

        this.jornada.unidadeId = this.unidadeId
        this.jornada.infraestruturaId = this.infraestruturaId
    },
    data:() => ({
        selecionados: false,
        jornada: {
            data: null,
            horaInicial: '',
            horaFim: '',
            infraestruturaId: null,
            infraestruturaNome: '',
            diasSemana: null,
            semanaId: null,
            unidadeId: null,
            tempoAtendimento: '',
            tipoId: null,
            tipoNome: null,
            selecionado: false,
            unidadeNome: '',
            vagas: '',
            periodo: {
                start: null,
                end: null,
            },
        },
        isReadOnly: false,
    }),
    mixins: [ repository, error, object, data, stringCase ],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        sortCompare(a, b, key) {

            if (key === 'data') {

                const dateA = moment(a[key], 'DD/MM/YYYY HH:mm')
                const dateB = moment(b[key], 'DD/MM/YYYY HH:mm')

                if (dateA > dateB) return 1
                else if (dateA < dateB) return -1
                else return 0

            } else {

                return false
            }
        },
        validate() {
            return this.$refs.Form.validate()
        },
        handleDestroy(item) {

            if(!item.agendamentos){

                const destroy = () => new Promise(resolve => {

                    const objId = this.model.jornadas.findIndex((obj => obj.jornadaId == item.jornadaId));

                    resolve(this.model.jornadas.splice(objId, 1))
                })
                .then(() => {

                    if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                        const objIndex = this.model.jornadasNotSave.findIndex((obj => obj.jornadaId == item.jornadaId));

                        this.model.jornadasNotSave.splice(objIndex, 1)
                    }

                    this.$emit('loadDays', this.model.jornadas)
                    this.handleBlur()
                })

                this.showDeleteConfirmation(`Deseja realmente excluir essa jornada?`, destroy)

            } else {

                this.showValidationNotification(`Esta jornada possui agendamento vinculado e não pode ser excluída.`)
            }
        },
        selecionarTodos(){

            if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                if(this.selecionados == true){

                    this.selecionados = false
                } else {

                    this.selecionados = true
                }

                this.model.jornadasNotSave.forEach(element => {

                    if(!element.agendamentos){

                        if(this.selecionados == true){

                            element.selecionado = true

                        } else {

                            element.selecionado = false
                        }
                    }
                })
            } else {

                if(this.selecionados == true){

                    this.selecionados = false
                } else {

                    this.selecionados = true
                }

                this.model.jornadas.forEach(element => {

                    if(!element.agendamentos){

                        if(this.selecionados == true){

                            element.selecionado = true

                        } else {

                            element.selecionado = false
                        }
                    }
                })
            }
        },
        deletarSelecionados(){

            if(this.selecionados == false){

                this.showAlert('É necessário selecionar uma jornada')

            } else {

                const destroy = async () => this.model.jornadas.filter(p => p.selecionado && p.agendamentos == 0)
                    .map(item => {

                        this.model.jornadas.splice(this.model.jornadas.indexOf(item),1)

                        if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                            this.model.jornadasNotSave.splice(this.model.jornadasNotSave.indexOf(item),1)
                        }

                        this.$emit('loadDays', this.model.jornadas)
                        this.handleBlur()
                    })

                this.showDeleteConfirmation(`Somente as jornadas sem agendamentos serão excluídas. Tem certeza de que
                    deseja excluir as jornadas selecionadas que não possuem agendamentos?`, destroy)
            }
        },
        getStringDiaSemana(dia) {

            if(dia == '1'){
               return 'DOMINGO'

            } else if (dia == '2'){
               return 'SEGUNDA-FEIRA'

            } else if (dia == '3'){
               return 'TERÇA-FEIRA'

            } else if (dia == '4'){
               return 'QUARTA-FEIRA'

            } else if (dia == '5'){
               return 'QUINTA-FEIRA'

            } else if (dia == '6'){
               return 'SEXTA-FEIRA'

            } else if (dia == '7'){
               return 'SÁBADO'
            }
        },
        getTempoAtendimento(tempo) {

            return tempo > 1 ? `${tempo} minutos` : `${tempo} minuto`
        },
        handleBlur(){

            let selecionado = false

            if (this.model.jornadasNotSave && this.model.jornadasNotSave.length > 0) {

                this.model.jornadasNotSave.map(jornada => {

                    if (jornada.selecionado == true) {

                        selecionado = true
                    }
                })

            } else {

                this.model.jornadas.map(jornada => {

                    if (jornada.selecionado == true) {

                        selecionado = true
                    }
                })
            }

            if (selecionado) {

                this.selecionados = true
            } else {

                this.selecionados = false
            }
        },
        getCalendar() {

            this.$emit('loadDays', this.model.jornadas)
        },
        search() {

            this.$refs.FormSearch.search()
        }
    },
    props: {
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        id: { type: Number },
        unidadeId: { type: Number },
        infraestruturaId: { type: Number }
    },
}
</script>